export default {
    required: "Dit veld is verplicht.",
    alphabetic: "Enkel alfabetische tekens en spaties zijn toegestaan.",
    alphanumeric: "Enkel alfanumerieke tekens en spaties zijn toegestaan.",
    phone: "Ongeldig telefoonnummer.",
    id_number: "Documentnummer moet uit 6 tot 9 letters of cijfers bestaan. Indien dit op het paspoort langer is volstaat het om de eerste 9 tekens in te vullen.",
    email: "Ongeldige email."
}
